module.exports = __webpack_public_path__ + "img/expostyle_1059_blacktulip_pantone7448c.b928b649.jpg";